import { useNavigate } from 'react-router-dom'

import { useAuth } from '@forbiz/web-kit'

import styles from '../app.module.css'
import { useAsync } from '../lib/useAsync.js'
import { invoicesApi, INVOICE_STATUS_LABEL } from '../lib/invoices.js'

/** 기업 청구 목록 (BIZ-16). 기업 관리자 자기 기업 청구만(서버가 범위). */

function won(n: number): string {
  return `${n.toLocaleString('ko-KR')}원`
}
function fmtDate(s: string | null): string {
  if (!s) return ''
  const d = new Date(s)
  return Number.isNaN(d.getTime()) ? s : d.toLocaleDateString('ko-KR')
}

export function InvoicesPage() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const isAdmin = user?.role === 'COMPANY_ADMIN'
  // URL 직접 진입 방어(네비는 관리자에게만 노출되지만 경로는 공유된다). 서버도 범위를 걸지만
  // 담당자·업체가 주소로 들어오면 빈 목록 대신 명확히 막는다.
  const { data, loading, error } = useAsync(
    () => (isAdmin ? invoicesApi.list() : Promise.resolve({ items: [], total: 0, limit: 0, offset: 0 })),
    [isAdmin],
  )
  const items = data?.items ?? []

  if (!isAdmin) {
    return (
      <main>
        <div className={styles.header}>
          <h1 className={styles.title}>청구 내역</h1>
        </div>
        <p className={styles.muted}>기업 관리자만 볼 수 있는 화면입니다.</p>
      </main>
    )
  }

  return (
    <main>
      <div className={styles.header}>
        <h1 className={styles.title}>청구 내역</h1>
      </div>

      {error ? (
        <div className={styles.error} role="alert">{error}</div>
      ) : loading ? (
        <p className={styles.muted}>불러오는 중…</p>
      ) : items.length === 0 ? (
        <p className={styles.muted}>청구 내역이 없습니다.</p>
      ) : (
        <div className={styles.tableScroll}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th scope="col">청구 월</th>
                <th scope="col">상태</th>
                <th scope="col" className={styles.num}>청구 금액</th>
                <th scope="col">지급 기한</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <tr
                  key={it.id}
                  className={styles.rowLink}
                  role="link"
                  tabIndex={0}
                  aria-label={`${it.billingMonth} 청구 상세`}
                  onClick={() => navigate(`/invoices/${it.id}`)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate(`/invoices/${it.id}`) } }}
                >
                  <td>{it.billingMonth}</td>
                  <td>{INVOICE_STATUS_LABEL[it.status]}</td>
                  <td className={styles.num}>{won(it.totalAmount)}</td>
                  <td>{fmtDate(it.dueAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </main>
  )
}
